// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Field__Component[data-v-920ca036] {\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
